import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  BookAppointmentInfoContainer,
  BookAppointmentInfoTitleContainer
} from './BookAppointmentWidget.styled';
import { CalendarPlus } from 'assets/icons/Icons';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import { usePatient } from 'hooks/usePatient/usePatient';
import { themes } from 'kb-shared';
import { networkClinicCopy } from 'screens/Book/networkClinicBookingCopy';
import { CONNECT_TO_CARE_SOURCE } from 'screens/BookingQuiz/bookingQuizSource';
import { CustomList } from 'screens/Dashboard/CustomWidget/Components/CustomList';
import {
  ButtonsContainer,
  IconContainer,
  IllustratedBackgroundWidget,
  WidgetTitleContainer
} from 'screens/Dashboard/Widgets/Widgets.styled';
import { analytics } from 'utilities/analytics';
import { pageUrl } from 'utilities/pageUrl';

import {
  componentDescription,
  componentTitle,
  getAppointmentsOfferString
} from './BookAppointmentWidget.utils';

export const BookAppointmentWidget: React.FC = () => {
  const navigate = useNavigate();
  const { patient } = usePatient();
  const { ppNetworkClinicBooking, _loading: featureFlagsLoading } = useFeatureFlags();

  const showPartnerClinicButton =
    patient?.patientMembership &&
    patient?.patientMembership?.membershipId &&
    patient?.patientMembership?.membership?.partnerClinicsEnabled;

  const openConnectToCareQuiz = () => {
    analytics.track(analytics.EVENTS.APPOINTMENT_BOOKING_STARTED);
    navigate(
      pageUrl.booking.bookingQuiz(
        ppNetworkClinicBooking || featureFlagsLoading
          ? { source: CONNECT_TO_CARE_SOURCE }
          : undefined
      )
    );
  };

  return (
    <IllustratedBackgroundWidget variant={9}>
      <IconContainer $iconWidth={42} $iconHeight={48}>
        <CalendarPlus type="solid" />
      </IconContainer>
      <WidgetTitleContainer>
        <Heading tag="div" styledAs="h2">
          {ppNetworkClinicBooking ? networkClinicCopy.dashboardTitle : componentTitle}
        </Heading>
      </WidgetTitleContainer>
      <BookAppointmentInfoTitleContainer>
        <Text color={themes.colors.neutral.primaryNavy} fontStyle="medium" size="lg">
          {componentDescription}
        </Text>
      </BookAppointmentInfoTitleContainer>
      <BookAppointmentInfoContainer>
        <CustomList items={getAppointmentsOfferString()} type="bulleted" />
      </BookAppointmentInfoContainer>

      <ButtonsContainer>
        {showPartnerClinicButton ? (
          <>
            <Button
              category="primary-dark"
              size="lg"
              fullWidth
              label={
                ppNetworkClinicBooking
                  ? networkClinicCopy.dashboardBookButton
                  : 'Book Your Appointment at Kindbody'
              }
              onClick={openConnectToCareQuiz}
            />
            <Button
              category="secondary"
              size="lg"
              fullWidth
              label={
                ppNetworkClinicBooking
                  ? networkClinicCopy.findClinic
                  : 'Find a Partner Clinic (for Patients with Kindbody Employer Benefits Only)'
              }
              onClick={() =>
                navigate(pageUrl.booking.index({ step: 'location', partnerClinicSearch: 'search' }))
              }
            />
          </>
        ) : (
          <Button
            category="primary-dark"
            size="lg"
            fullWidth
            label={
              ppNetworkClinicBooking ? networkClinicCopy.dashboardBookButton : 'Book an Appointment'
            }
            onClick={openConnectToCareQuiz}
          />
        )}
      </ButtonsContainer>
    </IllustratedBackgroundWidget>
  );
};
